
export const text = `[ID: A photo of a living room.  The camera appears to be situated on top of a dining table. There are five people in the picture. Three are playing a fighting game on an old console. They are laser-focused, not tearing their eyes away from the screen. One of them is sitting on the edge of the couch, waving at the camera with a wide smile. The last one is nearly out of frame, leaning on a wall close to a door. They seem to be staring at the camera as well.]
Follow the Herald.



`